/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
/* NPM Imports Start */
import React from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
/* NPM Imports End */

/* Project Imports Start */
import appInfo from './app-info';
import { privateRoutes as routes } from './app-routes';
import { SideNavInnerToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';
import { appVersion } from './constant';
import { useAuth } from './contexts/auth';
/* Project Imports End */

/* CCS & Image imports Start */

/* CCS & Image imports End */

const hasRequiredRole = (userAuthLevel, roles) => {
  return roles.length === 0 || roles.includes(userAuthLevel);
};

const ProtectedRoute = ({ component: Component, roles, user, ...rest }) => {
  const { userdetail } = user;
  const { customers } = userdetail;
  const userAuthLevel = customers[0].authLevel;

  return (
    <Route
      {...rest}
      render={props => {
        if (!hasRequiredRole(userAuthLevel, roles)) {
          return <Redirect to="/" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

const Content = () => {
  const { user } = useAuth();
  const location = useLocation();
  const hideSidebar = location.pathname.startsWith('/reportViewer');

  return hideSidebar ? (
    <Switch>
      {routes.map(({ path, component, roles }) => (
        <ProtectedRoute
          exact
          key={path}
          path={path}
          component={component}
          roles={roles}
          user={user}
        />
      ))}
    </Switch>
  ) : (
    <SideNavBarLayout title={appInfo.title}>
      <React.Suspense fallback={<div>Loading...</div>}>
        <Switch>
          {routes.map(({ path, component, roles }) => (
            <ProtectedRoute
              exact
              key={path}
              path={path}
              component={component}
              roles={roles}
              user={user}
            />
          ))}
        </Switch>
      </React.Suspense>
      <Footer>
        ONYX Insight fieldPRO {appVersion} - © {new Date().getFullYear()}{' '}
        Insight Analytics Solutions Limited.
      </Footer>
    </SideNavBarLayout>
  );
};

Content.display = 'Content';

export default Content;

/* PropsTypes Validation Start*/
ProtectedRoute.propTypes = {
  component: PropTypes.any,
};
/* PropsTypes Validation End*/

/* DefaultProps */

/* DefaultProps */
